export default __webpack_public_path__ + "static/media/010-flippers.acd20c5e.svg";